module.exports = __webpack_public_path__ + "img/icon-building.ab0307a0.svg";